<template>
	<v-dialog persistent v-model="dialog" max-width="700px">
		<v-form ref="form" v-model="valid" :lazy-validation="true" autocomplete="off">
			<v-card>
				<v-card-title>
					<span class="headline font-weight-bold">Modifica Movimento</span>
				</v-card-title>

				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-menu
									ref="menu"
									v-model="menu"
									:close-on-content-click="true"
									transition="scale-transition"
									offset-y
									max-width="290px"
									min-width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field v-model="editedItem.posix" label="Data di acquisto" readonly v-on="on"></v-text-field>
									</template>
									<v-date-picker v-model="editedItem.posix" no-title scrollable actions locale="it-IT">
										<v-spacer></v-spacer>
										<v-btn text color="primary" @click="menu = false">OK</v-btn>
									</v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" sm="6">
								<v-select
									label="Tipo"
									:items="[{ text: 'Entrata', value: 'entrata' }, { text: 'Uscita', value: 'uscita' }]"
									item-text="text"
									item-value="value"
									v-model="editedItem.kind"
									:rules="[rules.required]"
									required
								></v-select>
							</v-col>
							<v-col cols="12" sm="6">
								<v-select
									label="Categoria"
									:items="categories"
									item-text="title"
									item-value="id"
									v-model="editedItem.category_id"
									:rules="[rules.required]"
									required
								></v-select>
							</v-col>
							<v-col cols="12" sm="6">
								<v-text-field v-model="editedItem.name" label="Nome" :rules="[rules.required]" required></v-text-field>
							</v-col>
							<v-col cols="12" sm="6">
								<v-text-field
									v-model="editedItem.price"
									label="Prezzo"
									type="number"
									:rules="[rules.required]"
									required
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-textarea v-model="editedItem.description" label="Descrizione"></v-textarea>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="close">Cancella</v-btn>
					<v-btn color="primary" text @click="save">Salva</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>

<script>
import axios from 'axios'
import { mapMutations, mapActions, mapGetters } from 'vuex'

export default {
	name: 'EditForm',

	data() {
		return {
			editedItem: {},
			valid: false,
			menu: false,
			rules: {
				required: (value) => !!value || 'Campo obbligatorio.',
			},
		}
	},

	props: {
		item: { type: Object },
		categories: { type: Array },
	},

	computed: {
		...mapGetters(['getMovimentiEdit']),
		dialog: {
			get() {
				return this.getMovimentiEdit
			},
			set() {
				this.CHANGE_MOVIMENTI_EDIT(false)
			},
		},
	},

	methods: {
		...mapMutations(['CHANGE_MOVIMENTI_EDIT']),
		...mapActions(['update_movement']),

		close() {
			this.CHANGE_MOVIMENTI_EDIT(false)
		},

		async save() {
			if (this.$refs.form.validate()) {
				this.$emit('edit-submit', 'reset')

				try {
					const data = await this.update_movement(this.editedItem)

					this.$emit('edit-submit', 'ok')
					this.close()
				} catch (error) {
					this.$emit('edit-submit', 'error')
				}
			}
		},
	},

	watch: {
		dialog(val) {
			val || (this.close() && this.CHANGE_MOVIMENTI_EDIT(false))
		},
		item(val) {
			this.editedItem = val
		},
	},
}
</script>

<style></style>
